export default {"src":"/_next/static/media/check-dark.3d104507.svg","height":22,"width":41};